<template>
  <div class="login">
    <div class="login-contair">
      <div class="login-main">
        <div class="login-left">
          <img src="../../../assets/images/customer/login-bg.png" />
        </div>
        <div class="login-right">
          <div class="logo-right-main">
            <div class="logo">
              <img src="../../../assets/images/customer/logo.png" />
            </div>
          </div>
          <div class="title">欢迎登录商户端</div>
          <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="loginRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
          >
            <el-form-item prop="username">
              <span class="svg-container">
                <img src="../../../assets/images/customer/userName.png">
              </span>
              <el-input
                ref="username"
                v-model="loginForm.username"
                type="text"
                placeholder="请输入用户名"
              />
            </el-form-item>
            <el-form-item prop="password">
              <span class="svg-container">
                <img src="../../../assets/images/customer/passWord.png">
              </span>
              <el-input
                ref="password"
                v-model="loginForm.password"
                @keyup.enter.native="login('loginForm')"
                type="password"
                placeholder="请输入密码"
              />
            </el-form-item>
            <el-button
              type="primary"
              class="login-btn"
              @click.native.prevent="login('loginForm')"
              >登录</el-button
            >
          </el-form>
        </div>
      </div>
    </div>
    <div class="copy-right">
      <p class="copy">浙ICP备12004338号-5 | &copy;2020 杭州中仓供应链科技(集团)有限公司所有</p>
    </div>
  </div>
</template>

<script>
import { saveToken, saveDBUserRealName, deleteToken } from "common/js/storage";
import Customer from "models/customer";
export default {

  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
      },
    };
  },

  created() {},

  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.loginForm
          Customer.login(data).then(res => {
            if (res.success) {
              deleteToken()
              saveToken(res.result.token);
              saveDBUserRealName(res.result.username);
              this.$router.push('/customers/order-search')
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.login {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 35px;
  .login-contair {
    display: flex;
    justify-content: center;
    align-items: center;
    .login-main {
      display: flex;
      width: 1252px;
      height: 592px;
      .login-left,
      .login-right {
        height: 100%;
      }
      .login-left {
        width: 710px;
      }
      .login-right {
        flex-grow: 1;
        background-color: #fff;
        .logo-right-main {
          display: flex;
          justify-content: center;
          .logo {
            width: 153px;
            height: 64px;
            margin-top: 100px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .title {
          margin-top: 19px;
          color: #999;
          font-size: 16px;
          font-weight: 400;
          text-align: center;
        }
        .login-form {
          width: 350px;
          margin: 0 auto;
          margin-top: 45px;
        }
        /* svg样式 */
        .svg-container {
          position: absolute;
          width: 20px;
          height: 20px;
          left: 17px;
          top: 3px;
          z-index: 10;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .login-btn {
          width: 100%;
          height: 48px;
          border-radius: 0px;
          margin-top: 20px;
          background-color: #2E68EA!important;
          color: #fff!important;
        }
      }
    }
  }
  .copy-right {
    padding-top: 70px;
  }
}
</style>
<style lang="scss">
.login {
  .el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__content {
    display: flex;
    position: relative;
    height: 48px;
    .el-input,
    .el-input__inner {
      height: 48px;
      background: #f5f5f5;
    }
    .el-input__inner {
      padding-left: 55px;
      border: none;
      border-radius: 0px;
      font-size: 16px;
      color: #000;
      font-weight: 400;
    }
  }
}
</style>